import React, { useEffect, useState } from 'react';
import clsx from 'clsx'
import Card from '@mui/material/Card';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import { Avatar, Button, Typography, CardContent, Grid } from '@mui/material'
import PropTypes from 'prop-types'
import { history } from '../../../../utils'
import { useSelector, useDispatch } from 'react-redux'
import { dashboardAction, ordemServicoAction } from '_actions'
import { makeStyles } from '@mui/styles'
import { useDebounce } from 'use-debounce';
import { styled } from '@mui/material/styles';
import theme from './../../../../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 10,
    marginRight: 10,
    [theme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.main
  }
}));

const CustomAvatar = styled(Avatar)({
  height: 45,
  width: 45,
  backgroundColor: '#FFC107',
  [theme.breakpoints.down('md')]: {
    height: 35,
    width: 35,
    display: 'flex'
  },
})

const CardOrdemServico = (props) => {
  const { className, ...rest } = props
  const classes = useStyles();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [term, setTerm] = useState('');
  const [debounceTerm] = useDebounce(term, 1000);
  const [order] = useState('data');
  const [direction] = useState('desc');

  const ordensServicoPendentes = useSelector((state) => (state.dashboard ? state.dashboard.dashboard.ordensServicoPendentes : undefined))

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent="space-between">
          <Grid item styles={{ display: 'flex', flexDirection: 'column' }}>
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                {ordensServicoPendentes ? ordensServicoPendentes : 0}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="caption" gutterBottom>
                Ordens de serviço pendentes
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <CustomAvatar>
              <MiscellaneousServicesIcon sx={{ fontSize: 25, color: '#25261C' }} />
            </CustomAvatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card >
  );
}

CardOrdemServico.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string
}

export default CardOrdemServico
